export const readPipOuterWidth = (pipWindow: Window | null): number | null => {
  if (!pipWindow) {
    return null;
  }

  try {
    return pipWindow.outerWidth;
  } catch {
    return null;
  }
};
